import extranetUser from "@/api/extranet/user";
import { UserModule } from '@/store'

const euExtranetLogin = async () => {
  const response = await extranetUser.getUserHrInfo().catch(() => { });
  console.log("euExtranetLogin进入,response",response) //undefined  这里要执行根据eu的api函数，且最好是在
  if (response) {
    await UserModule.CheckLogin();
  }


}
export {
  euExtranetLogin,
}
